import React from "react";

const render = (type, record) => {
    if (type == "Single") {
        if (record.language_family == "LTR" || record.language_family == "RTL") {
            return <>{record.language_family}</>;
        }
        return <>{record.language?.name}</>;
    } else {
        return <>{record.language_pair?.name}</>;
    }
};

export default render;
